import { render, staticRenderFns } from "./RootElement.vue?vue&type=template&id=b70e24a4&functional=true&lang=pug&"
import script from "./RootElement.vue?vue&type=script&lang=js&"
export * from "./RootElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports